import { BrowseField } from './BrowseField'
import { DimensionBrowsePanel } from './DimensionBrowsePanel'
import type { FolderDimensionOption } from './DimensionMultiBrowsePanel'

type Props = {
  value?: number
  onChange?: (id: number | undefined) => void
  dimensions: FolderDimensionOption[]
  placeholder?: string
  disabled?: boolean
  className?: string
  trigger?: 'hover' | 'click'
  block?: boolean
  variant?: 'inline' | 'input'
}

function dimensionLabel(dim: FolderDimensionOption): string {
  return dim.is_manual ? '系统目录' : dim.name
}

export function KnowledgeDimensionBrowseField({
  value,
  onChange,
  dimensions,
  placeholder = '请选择虚拟分类',
  disabled,
  className,
  trigger = 'click',
  block = false,
  variant = 'inline',
}: Props) {
  const dim = dimensions.find((d) => d.id === value)
  const label = dim ? dimensionLabel(dim) : ''

  return (
    <BrowseField
      placeholder={placeholder}
      hidePlaceholder={variant !== 'input' && !!label}
      disabled={disabled}
      className={className}
      trigger={trigger}
      block={block}
      variant={variant}
      panelClassName="app-browse-popover-panel--dimension"
      panel={
        <DimensionBrowsePanel
          dimensions={dimensions}
          value={value}
          onChange={onChange}
        />
      }
    >
      {label ? <span className="app-browse-field-display-text">{label}</span> : null}
    </BrowseField>
  )
}
